module.exports = __webpack_public_path__ + "static/img/register_patient.137bd8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register_patient.jpg
// module id = 1NcT
// module chunks = 7